/**
 * MuiPopper
 */
const MuiPopper = {
  // @ts-ignore TODO remove ignore once MUI is upgraded
  styleOverrides: {
    root: {
      '& > .MuiPaper-root': {
        borderRadius: 4
      }
    }
  }
};
export default MuiPopper;